<template lang="pug">
  .popup-event.js-popup-event(v-if="content")
    .popup-event__layout
    .popup-event__content
      .popup-event__close(v-on:click="popupLocal('event', 'close')")
        SvgIcon(class='popup-event__close-ico' name="close" width="32" height="32")
      .popup-event__left(v-if="content.img")
        .popup-event__left-img(:style="{ backgroundImage: `url(${content.img})`}")
      .popup-event__right
        .popup-event__right-content
          .popup-event__right-title(v-html="content.title")
          .popup-event__right-date
            | {{content.date}}
          .js-scrollbar-test
            .popup-event__right-txt(v-html="content.text")
          .popup-event__right-btn-wr
            button.popup-event__right-btn(type="button" v-on:click="popupLocal('booking', 'show', content.id)")
              | Запланировать визит
            a.popup-event__right-btn(v-if="content.file", :href="content.file.lnk" target="_blank")
              | {{content.file.title}}

</template>

<script>
import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';
import EventBus from '@/eventBus';

// @ is an alias to /src

import 'perfect-scrollbar/css/perfect-scrollbar.css';
import PerfectScrollbar from 'perfect-scrollbar';
import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';
import {PopupHelpersVue} from '@/mixins/PopupHelpersVue';

export default {
  name: 'PopupEvent',

  mixins: [AjaxHelpersVue, PopupHelpersVue],

  components: {
    SvgIcon,
  },

  data() {
    return {
      content: null
    }
  },

  created() {
    // Данные для попапа загружены
    EventBus.$on('eventPopupDataLoaded', res => {
      this.content = res;

      this.$nextTick(() => {
        $('.js-popup-event').addClass('popup-event--show');
        this.appClasses('show');

        this.scrollInit();
      });
    });
  },

  methods: {
    popupLocal(type, action, id) {
      this.popup(type, action, id);
    },

    scrollInit() {
      if($('.js-scrollbar-test').length) {
          let ps = new PerfectScrollbar('.js-scrollbar-test', {
              wheelSpeed: 2,
              wheelPropagation: true,
              minScrollbarLength: 20
          });
    }
  },

  }
}
</script>
